import { render, staticRenderFns } from "./importChapter.vue?vue&type=template&id=6135c383&scoped=true"
import script from "./importChapter.vue?vue&type=script&lang=js"
export * from "./importChapter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6135c383",
  null
  
)

export default component.exports